<template>
  <v-dialog v-model="dialog" max-width="680px">
    <v-card>
      <v-card-title class="font-weight-bold mx-3">
        {{ $t("DeliveryPoint.Fields.stock_list") }}
        <v-spacer></v-spacer>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 text-center subtitle-1">
        <!-- 绑定仓库列表 -->
        <v-data-table
          :headers="headers"
          :items="relations"
          no-data-text=""
          disable-pagination
          hide-default-footer
          dense
        >
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="accent" outlined depressed @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from "@/i18n";
import DeliveryPoints from "@/api/delivery_points";

export default {
  name: "DialogBindStocks",

  props: {
    value: Boolean,
    title: String,
    deliveryPointId: [String, Number],
  },

  computed: {
    headers: () => {
      return [
        {
          text: i18n.t("Stock.Fields.stock_code"),
          align: "start",
          value: "stock_code",
        },
        {
          text: i18n.t("Stock.Fields.stock_name"),
          align: "start",
          value: "stock_name",
        },
      ];
    },
  },

  data: () => ({
    dialog: false,
    relations: []
  }),

  watch: {
    value: {
      immediate: true,
      handler() {
        this.dialog = this.value;
        if (this.value) {
          DeliveryPoints.fetchOne(this.deliveryPointId).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.relations = response.data.delivery_point.relations;
              }
            }.bind(this)
          );
        }else {
          this.relations = [];
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) this.$emit("close");
      },
    },
  },
};
</script>